<template>
  <div class="header-page">
    <div class="nav nav1"></div>
    <div class="nav nav2" @click="OpneImgSwiper">
      Screenshots
    </div>
    <div class="nav nav3" @click="OpenIntroduction">
      Introduction
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
    }
  },
  methods: {
    OpenIntroduction() {
      this.$emit('openIntro',true)
    },
    OpneImgSwiper() {
      this.$emit('openSwiper',true)
    }
  }
}
</script>
<style lang="scss" scoped>
.header-page{
  width: 100%;
  height: 300px;
  background: #fff;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  .img{
    width: 220px;
  }
  .img1{
    width: 220px;
    margin-left: 40px;
    cursor: pointer;
  }
  .nav{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 220px;
    height: 187px;
    cursor: pointer;
    font-size: 20px;
    color: #fff;
    -webkit-text-stroke: 1px #000; 
    font-weight: 600;
  }
  .nav1{
    background: url(../assets/nav1.png);
    background-size: 100% 100%;
    margin-right: 40px;
  }
  .nav2{
    background: url(../assets/nav2.png);
    background-size: 100% 100%;
    margin-right: 40px;
  }
  .nav3{
    background: url(../assets/nav3.png);
    background-size: 100% 100%;
  }
}
@media screen and (max-width: 768px) {
  .header-page{
    flex-direction: column;
    height: 1800px;
    .nav{
      width: 570px;
      height: 500px;
      font-size: 40px;
    }
    .nav1{
      margin-right: 0;
      margin-bottom: 60px;
    }
    .nav2{
      margin-right: 0;
      margin-bottom: 60px;
    }
  }
}
</style>